








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-copy',

})
export default class ICopy extends Vue {

  @Prop({type: [String], default: '#494949'}) protected color!: string
  @Prop({type: [String], default: '24'}) protected width!: string

}

